import React from 'react';
import styled from 'styled-components';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  position: relative;
`;

const TooltipText = styled.div`
  visibility: hidden;
  background-color: white;
  color: ${({ theme }) => theme.color.darkBlue};
  top: 0.3rem;
  height: 2rem;
  border-radius: 3rem;
  font-size: 1rem;
  white-space: nowrap;
  text-align: center;
  padding: 0.5rem 1rem;
  position: absolute;
  transition: opacity 0.1s, visibility 0.2s;
  @media ${({ theme }) => theme.device.mobileL} {
    white-space: normal;
`;

const Tooltip = ({ text, children }: TooltipProps) => {
  return (
    <TooltipContainer
      onMouseEnter={(e) => {
        const tooltip = e.currentTarget.querySelector('div') as HTMLElement;
        if (tooltip) {
          tooltip.style.visibility = 'visible';
          tooltip.style.opacity = '1';
        }
      }}
      onMouseLeave={(e) => {
        const tooltip = e.currentTarget.querySelector('div') as HTMLElement;
        if (tooltip) {
          tooltip.style.visibility = 'hidden';
          tooltip.style.opacity = '0';
        }
      }}
    >
      {children}
      <TooltipText>{text}</TooltipText>
    </TooltipContainer>
  );
};

export default Tooltip;
